/**
 * @Author: Zero
 * @Date: 2023-11-09 15:59:51
 * @Explain: 标签管理
 */

// utils
import {
  getLocalStorage,
  jsonParse,
  removeLocalStorage,
  setLocalStorage,
} from '@/utils/global';
// type
import { StoreKeyEnum } from '@/definition/common/data.d';

export type PredictiveTagsInfoType = {
  /** 是否打通inGame数据 */
  inGame: boolean;
  /** 是否开通业务白名单 */
  predictiveTagSwitch: boolean;
};

export type PredictiveAlertTypes = {
  /** key = 业务ID + 用户ID */
  [key: string]: {
    /** 提示信息展开状态 */
    isClose: boolean;
  };
};

export interface LabelManageState {
  /** 当前业务是否开启预测标记 & 是否已打通in-game数据 */
  predictiveTagsInfo: PredictiveTagsInfoType;
  /** 预测页面 - 提示信息展开状态 */
  predictiveAlert: PredictiveAlertTypes;
}

export type ModelType = {
  namespace: string;
  state: LabelManageState;
  reducers: {
    setPredictiveTagsInfo: (
      state: LabelManageState,
      action: { payload: any },
    ) => any;
    setPredictiveAlert: (
      state: LabelManageState,
      action: { payload: any },
    ) => any;
    resetPredictiveAlert: (
      state: LabelManageState,
      action: { payload: any },
    ) => any;
  };
};

const LabelManageModel: ModelType = {
  namespace: 'LabelManageModel',
  state: {
    predictiveTagsInfo: { inGame: false, predictiveTagSwitch: false },
    predictiveAlert:
      jsonParse(getLocalStorage(StoreKeyEnum.LABEL_MANA_PREDICTIVE_ALERT)) ||
      {},
  },
  reducers: {
    setPredictiveTagsInfo(state, action) {
      return {
        ...state,
        predictiveTagsInfo: action.payload,
      };
    },
    // 设置 预测页面 - 提示信息展开状态
    setPredictiveAlert(state, action) {
      setLocalStorage(StoreKeyEnum.LABEL_MANA_PREDICTIVE_ALERT, action.payload);
      return {
        ...state,
        predictiveAlert: action.payload || {},
      };
    },
    // 重置 预测页面 - 提示信息展开状态
    resetPredictiveAlert(state, action) {
      removeLocalStorage(StoreKeyEnum.LABEL_MANA_PREDICTIVE_ALERT);
      return {
        ...state,
        predictiveAlert: {},
      };
    },
  },
};

export default LabelManageModel;
